interface SuspendedOverlayProps {
  subscriptionStatus: string | null
  suspensionReason: string | null
  onContact: () => void
}

const REASON_COPY: Record<string, { title: string; body: string }> = {
  trial_ended: {
    title: 'Your trial has ended',
    body: 'Contact us to upgrade and restore access to your account.',
  },
  admin_suspend: {
    title: 'Your account has been suspended',
    body: 'Please contact support to resolve this issue and restore access.',
  },
}

export default function SuspendedOverlay({
  subscriptionStatus,
  suspensionReason,
  onContact,
}: SuspendedOverlayProps) {
  if (subscriptionStatus !== 'suspended') {
    return null
  }

  const copy = REASON_COPY[suspensionReason ?? ''] || REASON_COPY.admin_suspend

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div role="dialog" aria-modal="true" className="max-w-md w-full mx-4 rounded-xl bg-white p-8 shadow-2xl">
        <h2 className="text-2xl font-bold text-gray-900 mb-3">{copy.title}</h2>
        <p className="text-gray-600 mb-6">{copy.body}</p>
        <button
          type="button"
          onClick={onContact}
          className="w-full bg-primary-600 hover:bg-primary-700 text-white py-2 rounded-lg font-medium"
        >
          Contact sales
        </button>
      </div>
    </div>
  )
}
